import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { GeneralService } from '../services/general.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private generalService: GeneralService,
    private authService: AuthService,
  ) {}

  canActivate(): boolean {
    const token = localStorage.getItem('token');
    const tokenExpiry = localStorage.getItem('refreshToken');

    if (!token || !tokenExpiry) {
      this.authService.logout();
      return false;
    }

    return true;
  }

  private hasPassedTwoHours(tokenExpiryStr: string | null): void {
    if (!tokenExpiryStr) return;

    const expiryTimeMs = Date.parse(tokenExpiryStr);
    if (isNaN(expiryTimeMs)) {
      this.authService.logout();
      return;
    }

    const nowMs = Date.now();

    // 3. Lógica simple: ¿Ya es más tarde de la hora de morir?
    if (nowMs >= expiryTimeMs) {
      this.generalService.viewSnacAlert('Inicio de sesión requerido', 'alert', 'Sesión expirada');
      this.authService.logout();
    }
  }
}
